import { HttpContext, HttpContextToken } from "@angular/common/http";

export const systemLoader = new HttpContextToken<string>(() => "loader");

export const loaderContext = (contextValue: string) => new HttpContext().set(systemLoader, contextValue);

export const silentLoaderContext = () => loaderContext("silent");
